var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{on:{"click":function($event){_vm.config.align = 'left'}}},[_vm._v(" Left ")]),_c('div',{on:{"click":function($event){_vm.config.align = 'center'}}},[_vm._v(" Center ")]),_c('div',{on:{"click":function($event){_vm.config.align = 'right'}}},[_vm._v(" Right ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }